export function scrollToTargetAdjusted(ref: any, offset: number) {
  const elementPosition = ref.current.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}
